export default "__VITE_ASSET__DCcHLmuh__"